const variants = {
  squared: {
    borderRadius: 0,
  },
  rounded: {
    borderRadius: 2,
  },
};

export default variants;
